
export const primaryColor = '#3e4c57'
export const notActiveColor = '#cdcdcd'
